'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VTooltip = undefined;

var _VTooltip = require('./VTooltip');

var _VTooltip2 = _interopRequireDefault(_VTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VTooltip = _VTooltip2.default;
exports.default = _VTooltip2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VTooltip/index.js
// module id = 189
// module chunks = 0